import React from 'react';
import classNames from 'classnames';
import { IconButton, IconButtonBrandColors, IconButtonVariants } from '@hallmark/web.core.buttons.icon-button';
import { Typography, TypographyVariants } from '@hallmark/web.core.typography.typography';
import { IconNames } from '@hallmark/web.styles.fonts.icomoon';
import { ButtonGroup } from '../../../button-group/button-group';
import { AlignmentProps } from '../font-drawer-types';
import styles from '../font-drawer.module.scss';

const buttonList = [
  { icon: IconNames.AlignLeftBold, ariaLabel: 'Left Justify' },
  { icon: IconNames.AlignCenterBold, ariaLabel: 'Center Justify' },
  { icon: IconNames.AlignRightBold, ariaLabel: 'Right Justify' },
];

export const Alignment = ({
  addClass = '',
  label,
  buttonGroupClick,
  activeIndex,
  setActiveIndex,
}: AlignmentProps): React.ReactElement => {
  const wrapperClasses = classNames(styles.alignment, addClass);

  const handleIndexChange = (index: number) => {
    setActiveIndex(index);
    buttonGroupClick(index);
  };

  return (
    <div className={wrapperClasses}>
      <Typography variant={TypographyVariants.FieldLabel}>Align</Typography>

      <ButtonGroup
        ariaLabel={label}
        activeClassOverride={styles.active}
        defaultClickedIndex={activeIndex}
        onIndexChange={handleIndexChange}
        addClass={styles.containerButtons}
      >
        {buttonList.map(({ icon, ariaLabel }, index) => {
          return (
            <IconButton
              iconClasses={activeIndex === index ? styles.iconActive : styles.icons}
              icon={icon}
              ariaLabel={ariaLabel}
              click={() => null}
              addClass={styles.buttons}
              key={index}
              variant={IconButtonVariants.Circular}
              iconColor={activeIndex === index ? IconButtonBrandColors.White : IconButtonBrandColors.Purple}
            />
          );
        })}
      </ButtonGroup>
    </div>
  );
};
